import React from 'react';

// @ts-ignore
import userAgent from 'lib/currentUserAgent';

import {
  GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach
} from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';

import CoachingScheduleSessionRowInline from './CoachingScheduleSessionRowInline';
import CoachingScheduleSessionRowStacked from './CoachingScheduleSessionRowStacked';

type Props = {
  instance: GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach;
};

export default function CoachingScheduleUpcomingInstance(props: Props) {
  const { instance } = props;
  const InstanceRowComponent = userAgent.isDesktop()
    ? CoachingScheduleSessionRowInline
    : CoachingScheduleSessionRowStacked;

  return (<InstanceRowComponent {...instance} />);
}
